import React, { useMemo } from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';

import Splug from './Splug';

const FreemiumSplug = () => {
    const visible = useMemo(() => {
        const bootstrap = getBootstrap();
        return bootstrap.get('splug.visible');
    }, []);

    return visible ? <Splug /> : null;
};

export default FreemiumSplug;
